import DocumentLinksPage from "../components/DocumentLinksPage.jsx";

const documents = [
	{
		label: "VINCI IL TUO SACROSANTO RELAX",
		href: "/vinci-il-tuo-sacrosanto-relax.pdf",
	},
];

const RegolamentiConcorsi = () => {
	return (
		<DocumentLinksPage
			title="Regolamenti e concorsi"
			intro="In questa sezione trovi i regolamenti PDF dei concorsi attivi e dell'archivio iniziative."
			documents={documents}
		/>
	);
};

export default RegolamentiConcorsi;
